import { defineStore } from 'pinia';

export const useOffsetHelperStore = defineStore('offsetHelper', {
    state: () => ({
        scrollToTopOffset: 0,
    }),
    actions: {
        setScrollToTopOffset(offset) {
            this.scrollToTopOffset = offset;
        },
    },
});